import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'

  import Tabs from '@/components/common/Tabs.vue'
  import GroupCoursesTabView from '@/components/course/GroupCoursesTabView.vue'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'

  import useCourse from '@/composables/useCourse'
  import useI18n from '@/composables/useI18n'

  import { CourseModule } from '@/store/modules/course'

  import type { PropType } from 'vue'
  import type { MemberGroup } from '@/services/interfaces/Auth0'
  import type { CourseItem } from '@/services/interfaces/Course'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'AssignGroupCourseModal',
  props: {
    group: {
      type: Object as PropType<MemberGroup>,
      required: true,
    },
  },
  setup(__props) {

  

  const { groupCourses } = useCourse()
  const { translateString } = useI18n()

  const groupedExternalCourses = ref({} as { [key: string]: CourseItem[] })
  const groupedOwnedCourses = ref({} as { [key: string]: CourseItem[] })
  const activeTabIndex = ref(0)
  const submitAssignedCourses = ref(false)
  const submittingAssignedCourses = ref(false)
  const hasSelectedCourses = ref(false)
  const hasUnassignedCourses = ref(false)

  const coursesOwnedByCompany = computed(() => {
    if (!CourseModule.groupCourses) return []
    return CourseModule.groupCourses?.filter(
      (course) => course.ownedByCompany && ['ready', 'in_progress'].includes(course.state),
    )
  })

  const coursesOwnedByCompanySize = computed(() => {
    return Object.values(groupedOwnedCourses.value).flat().length
  })

  const externalCourses = computed(() => {
    if (!CourseModule.groupCourses) return []
    return CourseModule.groupCourses?.filter(
      (course) => !course.ownedByCompany && ['ready', 'in_progress'].includes(course.state),
    )
  })

  const externalCoursesSize = computed(() => {
    return Object.values(groupedExternalCourses.value).flat().length
  })

  const tabs = computed(() => {
    const _tabs = []

    if (coursesOwnedByCompany.value.length) {
      _tabs.push(
        `${translateString('homepage.assignedCourses.ownCourses')} <span>${coursesOwnedByCompanySize.value}</span>`,
      )
    }

    if (externalCourses.value.length) {
      _tabs.push(
        `${translateString('homepage.assignedCourses.externalCourses')} <span>${externalCoursesSize.value}</span>`,
      )
    }

    return _tabs
  })

  const isActiveTab = computed(() => (name: string) => tabs.value[activeTabIndex.value].startsWith(name))

  const headerTitle = computed(() => {
    return (key: string) => {
      if (key === 'trial') return translateString('homepage.assignedCourses.inTrial')
      if (key === 'inProgress') return translateString('homepage.assignedCourses.inprogressTrainings')

      return translateString('homepage.assignedCourses.otherTrainings')
    }
  })

  groupCourses(externalCourses.value, true, true, true).then((data) => {
    groupedExternalCourses.value = data as { [key: string]: CourseItem[] }
  })

  groupCourses(coursesOwnedByCompany.value, true, true, true).then((data) => {
    groupedOwnedCourses.value = data as { [key: string]: CourseItem[] }
  })

return { __sfc: true,groupCourses, translateString, groupedExternalCourses, groupedOwnedCourses, activeTabIndex, submitAssignedCourses, submittingAssignedCourses, hasSelectedCourses, hasUnassignedCourses, coursesOwnedByCompany, coursesOwnedByCompanySize, externalCourses, externalCoursesSize, tabs, isActiveTab, headerTitle, computed, ref, Tabs, GroupCoursesTabView, KetchUpButton, LoadingSpinner, useCourse, useI18n, CourseModule }
}

})